/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { Icon } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import { useEffect, useState } from "react";
import { connect } from "react-redux";

import CloseIcon from "@mui/icons-material/Close";
import Select from "react-select";

import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
// @mui material components
import MuiAlert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Snackbar from "@mui/material/Snackbar";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Dashboard components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Functions from store
import { createBanner, getBanner } from "../../store";

// Cookies
import { useFormik } from "formik";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const BannerAndLogo = ({ getBannerReducer, getBanner, createBanner }) => {
  let user = cookies.get("loginDetailsForWMS");
  let jwtToken = user?.jwt;
  let clientId = user?.data?.clientId;

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 350,
    boxShadow: 24,
    p: 0,
    pt: 3,
  };

  let email = user.data.email;

  useEffect(() => {
    getBanner(clientId, jwtToken);
  }, [clientId]);

  const [profileInfo, setProfileInfo] = useState({});

  useEffect(() => {
    let temp = getBannerReducer.banner ? getBannerReducer.banner.url : {};

    setProfileInfo(temp);
  }, [getBannerReducer]);

  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedLogo, setSelectedLogo] = useState(null);
  const [selectedMobileImage, setSelectedMobileImage] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  useEffect(() => {
    const storedImage = profileInfo;
    const storedLogo = localStorage.getItem("uploadedLogo");
    const storedMobileImage = localStorage.getItem("uploadedMobileImage");

    if (storedImage) {
      setSelectedImage(storedImage);
    }
    if (storedLogo) {
      setSelectedLogo(storedLogo);
    }
    if (storedMobileImage) {
      setSelectedMobileImage(storedMobileImage);
    }
  }, [getBannerReducer]);

  const [typeOfImageSelected, setTypeOfImageSelected] = useState(null);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");

  const handleTypeOfImageChange = (selectedOption) => {
    setTypeOfImageSelected(selectedOption);
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setSelectedImage(event.target.files[0]);
    if (selectedFile) {
      // File size validation (max 1MB)
      const maxSize = 1 * 1024 * 1024; // 1MB in bytes
      if (selectedFile.size > maxSize) {
        setFile(null);
        setFileName("");
        alert("File size must be less than or equal to 900KB.");
        return;
      }

      const img = new window.Image();
      const objectUrl = URL.createObjectURL(selectedFile);

      img.onload = () => {
        if (typeOfImageSelected && typeOfImageSelected.value === 1) {
          if (img.width !== 1920 || img.height !== 960) {
            setFile(null);
            setFileName("");
            alert("Image dimensions must be 1920 x 960 pixels.");
            URL.revokeObjectURL(objectUrl);
            return;
          }
        }
        // if (img.width === 1920 && img.height === 960) {
        //   setFile(selectedFile);
        //   setFileName(selectedFile.name);
        // } else {
        //   setFile(null);
        //   setFileName("");
        //   alert("Image dimensions must be 1920 x 960 pixels.");
        // }
        // URL.revokeObjectURL(objectUrl);
      };
      img.onerror = () => {
        setFile(null);
        setFileName("");
        alert("Invalid image file.");
        URL.revokeObjectURL(objectUrl);
      };
      img.src = objectUrl;
    }
  };

  const handleSubmit = (values) => {
    if (file && typeOfImageSelected) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const imageData = reader.result;
        if (typeOfImageSelected.value === 1) {
          setSelectedImage(imageData);
          localStorage.setItem("uploadedImage", imageData);
          createBanner(imageData, jwtToken);
        } else if (typeOfImageSelected.value === 2) {
          setSelectedLogo(imageData);
          localStorage.setItem("uploadedLogo", imageData);
        } else if (typeOfImageSelected.value === 3) {
          setSelectedMobileImage(imageData);
          localStorage.setItem("uploadedMobileImage", imageData);
        }
        setShowConfirmation(true);
      };
      reader.readAsDataURL(file);
      handleAddImageCloseModal();
    }
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
  };

  const [addImageModal, setAddImageModal] = useState(false);

  const handleAddImageModal = () => {
    setAddImageModal(true);
  };

  const handleAddImageCloseModal = () => {
    setAddImageModal(false);
    setTypeOfImageSelected("");
    setFile(null);
    setFileName("");
  };

  const formik = useFormik({
    initialValues: {
      ImageId: "",
    },
    onSubmit: handleSubmit,
  });

  const uploadOptions = [
    {
      label: "Banner",
      value: 1,
    },
    {
      label: "Logo",
      value: 2,
    },
    {
      label: "Mobile Logo",
      value: 3,
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Card
        sx={{
          width: { xs: "100%", sm: "100%", md: "0%", lg: "100%", xl: "100%" },
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: "50px",
          marginBottom: "100px",
        }}
      >
        <MDBox ml={2} mt={2}>
          <Tooltip title="Upload Image">
            <MDButton
              type="button"
              variant="outlined"
              color="info"
              onClick={handleAddImageModal}
              iconOnly
            >
              <Icon>file_upload</Icon>
            </MDButton>
          </Tooltip>
        </MDBox>
        <Divider />

        <Grid container spacing={3} alignItems="center">
          <Modal
            open={addImageModal}
            onClose={handleAddImageCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <MDCard sx={style}>
              <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                  Upload
                </MDTypography>
                <MDBox>
                  <Tooltip title="Close">
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      onClick={handleAddImageCloseModal}
                      style={{
                        background: "whitesmoke",
                        color: "black",
                        borderRadius: 5,
                        marginLeft: "-55px",
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </MDBox>
              </MDBox>
              <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />
              <MDBox pt={1} pb={3} px={3}>
                <MDBox
                  component="form"
                  role="form"
                  onSubmit={formik.handleSubmit}
                >
                  <MDBox mb={1}>
                    <MDTypography variant="h6" style={{ fontWeight: "500" }}>
                      Select Type
                    </MDTypography>
                    <Select
                      isClearable
                      className="select-css"
                      maxMenuHeight={130}
                      placeholder="Choose one..."
                      name="ImageId"
                      onBlur={() => {
                        formik.handleBlur({ target: { name: "ImageId" } });
                      }}
                      value={typeOfImageSelected}
                      options={uploadOptions}
                      onChange={(selectedOption) => {
                        handleTypeOfImageChange(selectedOption);
                        formik.setFieldValue("ImageId", selectedOption);
                      }}
                    />
                  </MDBox>
                  <MDBox mt={2}>
                    <MDTypography variant="h6" style={{ fontWeight: "500" }}>
                      Choose an Image
                    </MDTypography>
                    <MDButton
                      variant="outlined"
                      component="label"
                      color="info"
                      style={{ width: "19rem" }}
                    >
                      Choose File
                      <input type="file" hidden onChange={handleFileChange} />
                    </MDButton>
                    {fileName && (
                      <MDTypography
                        variant="subtitle1"
                        style={{ marginTop: "0.5rem" }}
                      >
                        {fileName}
                      </MDTypography>
                    )}
                  </MDBox>
                  <MDBox mt={3}>
                    <MDButton color="success" fullWidth type="submit">
                      Submit
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </MDCard>
          </Modal>
        </Grid>
        {/* <Divider /> */}
        <Grid container spacing={1} ml={2} mt={2}>
          {selectedImage && (
            <Grid item xs={12} sm={6} md={4}>
              <MDTypography variant="h3">Banner</MDTypography>
              <img
                src={profileInfo}
                alt="Banner"
                style={{ width: "80%", height: "20vh" }}
              />
            </Grid>
          )}
          {selectedLogo && (
            <Grid item xs={12} sm={6} md={4}>
              <MDTypography variant="h3">Logo</MDTypography>
              <img
                src={selectedLogo}
                alt="Logo"
                style={{ width: "80%", height: "20vh" }}
              />
            </Grid>
          )}
          {selectedMobileImage && (
            <Grid item xs={12} sm={6} md={4}>
              <MDTypography variant="h3">Mobile Logo</MDTypography>
              <img
                src={selectedMobileImage}
                alt="Mobile"
                style={{ width: "80%", height: "20vh" }}
              />
            </Grid>
          )}
        </Grid>
      </Card>

      <Footer />

      <Snackbar
        open={showConfirmation}
        autoHideDuration={3000}
        onClose={handleCloseConfirmation}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        style={{ marginTop: "1rem" }}
      >
        <MuiAlert
          onClose={handleCloseConfirmation}
          severity="success"
          sx={{ width: "100%" }}
        >
          Image uploaded successfully!
        </MuiAlert>
      </Snackbar>
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getBannerReducer: state.getBannerReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getBanner: (clientId, jwtToken) => dispatch(getBanner(clientId, jwtToken)),
    createBanner: (payload, jwtToken) =>
      dispatch(createBanner(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BannerAndLogo);
